import React, {useState, useContext, useRef} from 'react';
import { IonContent, IonText, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol } from '@ionic/react';
import { IonImg, IonLabel } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import {Plugins, CameraResultType } from '@capacitor/core';

import '../../../../css/qavaApp.css';
import {  UploadedInvoiceTemplates } from '../components/MerchantAccountSettingAppComps';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context'

const { Filesystem } = Plugins;
const { Camera } = Plugins;


//export class AccountSetting extends React.Component {
export function AccountSetting () {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    let [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    let [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [showInvoiceTemplates, setShowInvoiceTemplates] = useState(false);
    let [showFormTemplates, setShowFormTemplates] = useState(false);
    let [selectedFile, setSelectedFile] = useState(null);
    let [showPaymentMethod_checkingModal, setShowPaymentMethod_checkingModal] = useState(false);
    let [showCompanySetting_onlineImageModal, setShowCompanySetting_onlineImageModal] = useState(false);
    let [showCompanySetting_publicShowcaseModal, setShowCompanySetting_publicShowcaseModal] = useState(false);
    let [showCompanySetting_selectedImageModal, setShowCompanySetting_selectedImageModal] = useState(false);
    let [companyOnlineImage, setCompanyOnlineImage] = useState(null);
    let [viewPublicShowcaseData, setViewPublicShowcaseData] = useState([]);
    let [showcaseGalleryTracker, setShowcaseGalleryTracker] = useState(null);
    let [showcaseGalleryTracker_addition, setShowcaseGalleryTracker_addition] = useState(null);
    let [showcaseGalleryTracker_updated, setShowcaseGalleryTracker_updated] = useState(null);
    let [showcaseName, setShowcaseName] = useState(null);
    let [showcaseImagePath, setShowcaseImagePath] = useState(null);
    let [showcaseFormData, setShowcaseFormData] = useState(null);
    let [style_showcaseGalleryView, setStyle_showcaseGalleryView] = useState('zProServiceShowcase_acctGallaryView');
    let [firstSelectedImage, setFirstSelectedImage] = useState(true);
    let [enlarge_selectedShowcaseImage, setEnlarge_selectedShowcaseImage] = useState(null);
    let [background_selectedShowcaseImage, setBackground_selectedShowcaseImage] = useState(null);
    let [display_addImages, setDisplay_addImages] = useState('inline-block');
    let [display_saveAdditionChanges, setDisplay_saveAdditionChanges] = useState('inline-block');
    let [display_saveDeletionChanges, setDisplay_saveDeletionChanges] = useState('none');
    let [display_background, setDisplay_background] = useState('yellow');
    let [showcaseGallery_deletionSelection, setShowcaseGallery_deletionSelection] = useState([]);
    let [buttonPressTimer, setButtonPressTimer] = useState(null);


    let bankAccountName = useRef();
    let bankAccountNumber = useRef();
    let routingNumber = useRef();
    let bankName = useRef();
    let branchName = useRef();


function handleEnterCompanyOnlineImage(e) {  

    if(e.target.files == null)
    {
        setCompanyOnlineImage("/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg")
    }
    else
    {
        setCompanyOnlineImage(e.target.files[0])
    }
}

function handleEnterPublicShowcaseImages(e) {  

    let numOfImages = e.target.files.length;
    let aa = showcaseGalleryTracker;

    if (e.target.files)
    {

        let formData = new FormData();
        formData.append('Tracker', '72003D');
        formData.append('user', acctID);


        for(let i = 1; i <= numOfImages; ++i)
        {
            formData.append('xCompanyShowcase'+(aa+i), e.target.files[i-1]);
        }
 
        setShowcaseGalleryTracker_addition(numOfImages);
        setShowcaseGalleryTracker_updated( aa+numOfImages);
        setShowcaseFormData(formData);

    }
}

function saveUploadedFile(event) {

        setSelectedFile(event.target.files[0])
    }



    async function uploadFile() {

        const formData = new FormData();
        formData.append('originalFormFile', selectedFile);
        formData.append('Tracker', 72003);
        formData.append('user', acctID);
        formData.append('merchantSchema', schema);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }

        fetch('https://ghanaverified.com/merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);

        })
    }

    // image.webPath will contain a path that can be set as an image src.
    // You can access the original file using image.path, which can be
    // passed to the Filesystem API to read the raw data of the image,
    // if desired (or pass resultType: CameraResultType.Base64 to getPhoto)
    /*async  takePicture() {
        let image = await Camera.getPhoto({
            quality: 90,
            allowEditing: false,
            resultType: CameraResultType.Uri
        })

        let imageUrl = image.webPath;
        let imagePath = image.path;

        setSelectedFile(imagePath)
    }*/

    function handleSavePaymentMethod_checking() {

        const requestOptions = {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
             },
            body: JSON.stringify({
                Tracker: '72003A',
                user: acctID,
                //merchantSchema: schema,
                uEnterBankAcctName: bankAccountName.current.value,
                uEnterAcctNumber: bankAccountNumber.current.value,
                uEnterRoutingNumber: routingNumber.current.value,
                uEnterBankName: bankName.current.value,
                uEnterBankBranch: branchName.current.value,

            })
        }

        fetch("https://ghanaverified.com/merchantAcct_argsjqApp",requestOptions)
        .then(res => res.text())
        .then(res => {
            
            alert(res);

            setShowPaymentMethod_checkingModal(false);
        })
    }

    function uploadCompanySetting_onlineImage() {

        let formData = new FormData();
        formData.append('uCompanyOnlineImage', companyOnlineImage);
        formData.append('Tracker', '72003B');
        formData.append('user', acctID);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method: 'POST',
            credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                //'content-type': 'application/json',
             },
            file: formData,
            body: formData,
            contentType: false,
            processData: false,
            /*body: JSON.stringify({
                Tracker: '72001B',
                user: acctID,
            })*/
        }

        fetch("https://ghanaverified.com/merchantAcct_argsjqApp",requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);
            
            setShowCompanySetting_onlineImageModal(false);
        })
    }

    function getPublicShowcaseDetails() {

        const requestOptions = {
            method: 'POST',
            credentials: 'include',
            headers: {'content-type': 'application/json' },
            body: JSON.stringify({
                Tracker: "72003C",
                user: acctID,
            }),
        }
        
        fetch('https://ghanaverified.com/merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');

            setShowcaseGalleryTracker(rows.length - 1);

            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

                setViewPublicShowcaseData((prevViewPublicShowcaseData) => {
                    return prevViewPublicShowcaseData.concat({
                        id: cols[0], 
                        location: cols[1], 
                        description: cols[2], 
                        dateAdded: cols[3], 
                        image: cols[4]
                    })
                });
            } 
        })
    }

    function saveShowcaseUpdateAdditions(e)
    {


        const requestOptions = {
            enctype: 'multipart/form-data',
            method: 'POST',
            credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                //'content-type': 'application/json',
             },
            file: showcaseFormData,
            body: showcaseFormData,
            contentType: false,
            processData: false,
            /*body: JSON.stringify({
                Tracker: '72001B',
                user: acctID,
            })*/
        }

        fetch("https://ghanaverified.com/merchantAcct_argsjqApp",requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);
            
            setShowCompanySetting_onlineImageModal(false);
        })

    }

    function saveShowcaseUpdateDeletions(e)
    {

        let formData = new FormData();
        formData.append('Tracker', '72003E');
        formData.append('user', acctID);

        showcaseGallery_deletionSelection.map((photoID) => {

            formData.append('xShowcaseImgDeletion'+(photoID.id), photoID.id);
        })

        const requestOptions = {
            enctype: 'multipart/form-data',
            method: 'POST',
            credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                //'content-type': 'application/json',
             },
            //file: showcaseFormData,
            body: formData,
            contentType: false,
            processData: false,
            /*body: JSON.stringify({
                Tracker: '72003E',
                user: acctID,
            })*/
        }

        fetch("https://ghanaverified.com/merchantAcct_argsjqApp",requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);
            
            setShowCompanySetting_onlineImageModal(false);
        })

    }


    function handleButtonPress(event) 
    {


        let mouseIsDown = event[1];

        if(firstSelectedImage == false)
        {

            setShowcaseGallery_deletionSelection((prevShowcaseGallery_deletionSelection) => {
                return prevShowcaseGallery_deletionSelection.concat({
                    id: event[2], 
                })
            });

            const el = document.querySelector('#zProServiceShowcase_acctGallaryView'+event[2]);
            el.style.setProperty('background', 'green');

        }
        else
        {
            setButtonPressTimer(() => setTimeout(() => {

                setShowcaseGallery_deletionSelection((prevShowcaseGallery_deletionSelection) => {
                    return prevShowcaseGallery_deletionSelection.concat({
                        id: event[2], 
                    })
                });

                setFirstSelectedImage(false);
                setDisplay_addImages('none');
                setDisplay_saveAdditionChanges('none');
                setDisplay_saveDeletionChanges('inline-block');


                const el = document.querySelector('#zProServiceShowcase_acctGallaryView'+event[2]);
                el.style.setProperty('background', 'green');

            }, 1000));

        }

    }

    function handleButtonRelease (event) {

        if(firstSelectedImage == true)
        {
            clearTimeout(buttonPressTimer);
            setShowCompanySetting_selectedImageModal(true);
            setEnlarge_selectedShowcaseImage(event[3]);
        }


      }

    function updateShowCompanySetting_publicShowcaseModal(event) {

        if(event)
        {

            setShowCompanySetting_publicShowcaseModal(event);

            getPublicShowcaseDetails();
        }
        else
        {

            setShowCompanySetting_publicShowcaseModal(event);
            setViewPublicShowcaseData([]);
            setShowcaseGallery_deletionSelection([]);
            setFirstSelectedImage(true);
            setDisplay_addImages('inline-block');
            setDisplay_saveAdditionChanges('inline-block');
            setDisplay_saveDeletionChanges('none');
            setShowcaseGalleryTracker_addition(null);
            setShowcaseGalleryTracker_updated(null);
            setShowcaseFormData(null);

        }

    }


    return (
        //{/*<div className='ion-page'>*/}
            <IonReactRouter>
            {/*<IonRouterOutlet id="qavaAppConfirmed">*/}
                <IonHeader>
                    <IonToolbar>
                        <IonTitle size="large" class="appTitle">QAVA</IonTitle>
                        <IonTitle size="small" class="appTitle" > { acctID } </IonTitle>
                        <IonTitle size="large" class="appTitle" > { schema } </IonTitle>
                        <IonButtons slot='end'>
                            <IonMenuButton autoHide='false'></IonMenuButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent>
                    <IonList class="invoiceSettings">
                        <IonModal id='showInvoiceTemplates' isOpen={ showInvoiceTemplates }>
                            <UploadedInvoiceTemplates accountID= { acctID } schemaName={ schema }/>

                            <IonButton onClick={() => setShowInvoiceTemplates(false)}>
                                Close Modal
                            </IonButton>
                        </IonModal>
                        <IonTitle size='large'>Invoices</IonTitle>
                        <IonItem> 
                            <h1>Upload Invoice Template</h1>
                            <form id='fileUpload' enctype='multipart/form-data'>
                                <input type='file' name='imageFile' accept="image/*" onChange={(e) => saveUploadedFile(e)}></input>
                                <input type="button" value="upload" onClick={uploadFile} ></input>
                            </form>
                        </IonItem> 
                        <h1>Status</h1>
                        <IonButton onClick={() => setShowInvoiceTemplates(true)}>View Invoice Uploaded</IonButton>
                    </IonList>
                    <IonList class="formsSettings">
                        <IonModal id='showFormTemplates' isOpen={showFormTemplates}>
                            <IonGrid class="settingTable">
                                <IonRow>
                                    <IonCol>
                                        <h1>Image ID</h1>
                                    </IonCol>
                                    <IonCol>
                                        <h1>Original Image</h1>
                                        
                                    </IonCol>
                                    <IonCol>
                                        <h1>Postscript Image</h1>
                                    </IonCol>
                                    <IonCol>
                                        <h1>Actons</h1>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        <IonButton onClick={() => setShowFormTemplates(false)}>
                            Close Modal
                        </IonButton>
                        </IonModal>
                        <IonTitle size='large'>Forms</IonTitle>
                        <IonItem> 
                            <h1>Upload Form Template</h1>
                            <IonButton>Browse</IonButton>
                            <IonButton>upload</IonButton>
                        </IonItem> 
                        <IonItem> 
                            <h1>Status</h1>
                            <IonButton onClick={() => setShowFormTemplates(true)}>View Forms Uploaded</IonButton>
                        </IonItem>
                    </IonList>
                    <IonList>
                        <IonTitle size='large'>Payment Methods</IonTitle>
                        <IonItem> 
                            <IonButton onClick={() => setShowPaymentMethod_checkingModal(true)}>checking</IonButton>
                        </IonItem> 
                        <IonModal id='showPaymentMethod_checkingModal' isOpen={showPaymentMethod_checkingModal}>
                            <IonGrid class="settingTable">
                                <IonRow>
                                    <IonCol>
                                        <IonLabel>Account Name: </IonLabel>
                                        <IonInput placeholder='Enter Bank Account Name' ref={bankAccountName }></IonInput>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol>
                                        <IonLabel>Account Number: </IonLabel>
                                        <IonInput placeholder='Enter Bank Account Number (17 characters max)' maxlength='17' ref={bankAccountNumber }></IonInput>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol>
                                        <IonLabel>Routing Number: </IonLabel>
                                        <IonInput placeholder='Enter Bank Routing Number (9 characters exact)' maxlength='9' ref={routingNumber }></IonInput>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol>
                                        <IonLabel>Bank Name: </IonLabel>
                                        <IonInput placeholder='Enter Bank Name' ref={bankName }></IonInput>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol>
                                        <IonLabel>Branch Name: </IonLabel>
                                        <IonInput placeholder='Enter Bank Branch Name' ref={branchName }></IonInput>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol>
                                        <IonButton onClick={() => handleSavePaymentMethod_checking()}> Save </IonButton>
                                    </IonCol>
                                    <IonCol>
                                        <IonButton onClick={() => setShowPaymentMethod_checkingModal(false)}> Cancel </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonModal>
                    </IonList>
                    <IonList>
                        <IonTitle size='large'>Company Online Setting</IonTitle>
                        <IonItem> 
                            <IonButton onClick={() => setShowCompanySetting_onlineImageModal(true)}> Company Image</IonButton>
                        </IonItem> 
                        <IonModal id='showCompanySetting_onlineImage' isOpen={showCompanySetting_onlineImageModal}>
                            <IonGrid class="settingTable">
                                <IonItem>
                                    <form id='fileUpload' enctype='multipart/form-data'>
                                        <label for='createMerchantCompanyImage'>Upload Company Online Image</label>
                                            <input id='createMerchantCompanyImage' type='file' name='imageFile' accept="image/*" onChange={(e) => handleEnterCompanyOnlineImage(e)}></input>
                                        <label for='noAttachment'>No Attachment</label>
                                            <input type='checkbox' id='noAttachment' value='noImage' onClick={(e) => handleEnterCompanyOnlineImage(e)}></input>
                                    </form>   
                                </IonItem>
                                <IonRow>
                                    <IonCol>
                                        <IonButton onClick={() => uploadCompanySetting_onlineImage()}> Save </IonButton>
                                    </IonCol>
                                    <IonCol>
                                        <IonButton onClick={() => setShowCompanySetting_onlineImageModal(false)}> Cancel </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonModal>
                    </IonList>
                    <IonList>
                        <IonTitle size='large'>View Public Showcase Images</IonTitle>
                        <IonItem> 
                            <IonButton onClick={() => updateShowCompanySetting_publicShowcaseModal(true)}> Update Public Showcase</IonButton>
                        </IonItem> 
                        <IonModal id='showCompanySetting_publicShowcase' isOpen={showCompanySetting_publicShowcaseModal}>
                            <IonContent>
                            <IonGrid >
                                <IonRow>
                                    <IonCol style={{display: display_addImages}}>
                                        <IonItem>
                                            <form id='showcaseImageAdditions' enctype='multipart/form-data'>
                                                <label for='createMerchantCompanyImage'>Add Image</label>
                                                    <input id='createMerchantCompanyImage' type='file' name='imageFile' accept="image/*" onChange={(e) => handleEnterPublicShowcaseImages(e)} multiple></input>
                                                <label for='noAttachment'>No Attachment</label>
                                                    <input type='checkbox' id='noAttachment' value='noImage' onClick={(e) => handleEnterPublicShowcaseImages(e)}></input>
                                            </form>   
                                        </IonItem>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    {viewPublicShowcaseData.map((photoData) =>   {
                                        return (
                                            <IonCol id={'zProServiceShowcase_acctGallaryView'+photoData.id} size='4'>
                                                <IonText>
                                                    {photoData.id}
                                                </IonText>
                                                <IonImg
                                                    class='zProServiceShowcase_img'
                                                    src={photoData.image} 
                                                    onMouseDown={() =>
                                                        handleButtonPress([
                                                            this,
                                                            true,
                                                            photoData.id,
                                                            photoData.image,
                                                        ])
                                                    }
                                                    onMouseUp={() =>
                                                        handleButtonRelease([
                                                            this,
                                                            false,
                                                            photoData.id,
                                                            photoData.image,
                                                        ])
                                                    }
                                                ></IonImg>
                                                <IonText>
                                                    {'photoData.location' + ' ' + 'photoData.description'}
                                                </IonText>
                                            </IonCol>
                                        )
                                    }
                                    )}
                                </IonRow>
                                <IonRow>
                                    <IonCol>
                                        <IonButton onClick={() => saveShowcaseUpdateAdditions()} style={{display: display_saveAdditionChanges}}> Save Changes </IonButton>
                                    </IonCol>
                                    <IonCol>
                                        <IonButton onClick={() => saveShowcaseUpdateDeletions()} style={{display: display_saveDeletionChanges}}> Confirm Deletions </IonButton>
                                    </IonCol>
                                    <IonCol>
                                        <IonButton onClick={() => updateShowCompanySetting_publicShowcaseModal(false)}> Cancel </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                            </IonContent>
                        </IonModal>
                        <IonModal id='showCompanySetting_selectedImage' isOpen={showCompanySetting_selectedImageModal}>
                            <IonGrid>
                                <IonRow>
                                    <IonCol>
                                        <IonImg
                                                class='zProServiceShowcase_img'
                                                src={enlarge_selectedShowcaseImage} 
                                            ></IonImg>
                                            <IonButton onClick={() => setShowCompanySetting_selectedImageModal(false)}> Close </IonButton>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </IonModal>
                    </IonList>
                </IonContent>
            {/*</IonRouterOutlet>*/}
            </IonReactRouter>
        //{/*</div>*/}
    );
};



export default AccountSetting;